import React, {useEffect, useState} from 'react';
import {connect, useSelector} from "react-redux";
import {Navigate} from "react-router-dom";

const Invalidation = ({isOperator, isAuthenticated, accessToken, refreshToken}) => {

  const [webgisUrl, setWebgisUrl] = useState(null);

  useEffect(() => {
    if (accessToken && refreshToken) {
      setWebgisUrl(`${process.env.REACT_APP_WEBGIS_API_ADDRESS}?jwtAuth=${encodeURIComponent(accessToken)}&refresh=${encodeURIComponent(refreshToken)}&flow=invalidation`);
    }
  }, [accessToken, refreshToken]);

  // Access Control
  const isOper = useSelector((state) => state.auth.isOperator)
  const isAuth = useSelector((state) => state.auth.isAuthenticated)
  if (!isOper || !isAuth) {
    return <Navigate to="/" />;
  }

  return (
      isAuthenticated && isOperator &&
          <>
            <iframe style={{width: '100%', minHeight: 'calc(100vh - 200px)', marginTop: `90px`}} src={webgisUrl}/>
          </>
  )
}

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated,
  accessToken: state.auth.access,
  refreshToken: state.auth.refresh,
  isOperator: state.auth.isOperator
});

export default connect(mapStateToProps, {})(Invalidation);
